import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  errorLinkManualPaymentButton:
    'The provided link is not valid. Please check the URL and try again.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const MANUAL_PAYMENT_BUTTON_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    errorLinkManualPaymentButton:
      'El enlace proporcionado no es válido. Por favor, verifica la URL y vuelve a intentarlo.',
  },
};

export default MANUAL_PAYMENT_BUTTON_LABELS;
